import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useGlobals } from 'src/shared/contexts/appContext';
import { markAsHandled } from 'src/shared/services/depositService';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import FormLoaderWrapper from 'src/shared/components/organisms/formLoaderWrapper';

type GiftDetailMarkAsHandledDialogProps = {
  depositId: number;
  showDialog: boolean;
  callback: () => void;
};

export const GiftDetailMarkAsHandledDialog = (props: GiftDetailMarkAsHandledDialogProps) => {
  const { depositId, showDialog, callback } = props;
  const isMounted = useIsMounted();
  const { setDateStamp } = useGlobals();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [loading] = useState<boolean>(false);

  const componentId = `dialog-${Date.now().toString(36) + Math.random().toString(36).substring(2)}`;

  const { t } = useTranslation(['common', 'gift']);

  const handleClose = () => {
    setDateStamp(new Date());
    callback();
  };

  const handleCancel = async () => {
    setIsSubmitting(true);
    try {
      await markAsHandled(depositId);
      setTimeout(() => {
        if (isMounted()) {
          toast.success(<>{t('gift:markAsHandledSuccess')}</>);
          setDateStamp(new Date());
          callback();
        }
      }, 1000); // För att det ska hinna registreras innan gåvan laddas om
    } catch (e) {
      if (isMounted()) {
        toast.error(<>{t('gift.markAsHandledError')}</>);
        callback();
      }
    }
  };

  return (
    <Dialog open={showDialog} onClose={handleClose} aria-labelledby={`${componentId}-title`} sx={{ minHeight: '10rem' }}>
      <FormLoaderWrapper loading={loading}>
        <>
          <DialogTitle id={`${componentId}-title`}>{t('gift:markAsHandledPromt')}</DialogTitle>
          <DialogActions>
            <Button onClick={handleClose} variant='outlined'>
              {t('common:button.cancel')}
            </Button>
            <LoadingButton onClick={handleCancel} autoFocus disableElevation loading={isSubmitting} variant='contained' type='submit'>
              {t('common:button.handle')}
            </LoadingButton>
          </DialogActions>
        </>
      </FormLoaderWrapper>
    </Dialog>
  );
};
